<template>
  <div class="pt-legend">
    <div class="pt-legend__toggle">
      <div
        :class="[isLegendActive ? 'active' : '', 'pt-legend__button legend']"
        @click="toggleLegend"
      >
        <r-icon name="help" :size="20" :active="isLegendActive" />
      </div>
    </div>

    <div class="pt-legend__content" v-if="isLegendActive">
      <div class="pt-legend-header">
        Легенда
      </div>
      <ul class="pt-legend__list">
        <li class="pt-legend__item">
          <div class="pt-legend__item-key">
            <div class="pt-legend__item-symbol nodes" />
          </div>
          <div class="pt-legend__item-value">
            Узлы
          </div>
        </li>
        <li class="pt-legend__item">
          <div class="pt-legend__item-key">
            <div class="pt-legend__item-symbol links" />
          </div>
          <div class="pt-legend__item-value">
            Отрезки
          </div>
        </li>
        <li class="pt-legend__item">
          <div class="pt-legend__item-key">
            <div class="pt-legend__item-symbol stop_points" />
          </div>
          <div class="pt-legend__item-value">
            Остановки
          </div>
        </li>
        <li class="pt-legend__item">
          <div class="pt-legend__item-key">
            <div class="pt-legend__item-symbol line_routes" />
          </div>
          <div class="pt-legend__item-value">
            Маршруты
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["is-legend-active", "mode"],
  methods: {
    toggleLegend() {
      this.$emit("toggle-legend");
    }
  }
};
</script>

<style lang="scss">
.pt-legend {
  position: absolute;
  right: 16px;
  top: 176px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;

  &__toggle {
    color: var(--text_primary) !important;
    background-color: var(--modal_bg) !important;
    border-radius: 4px;
  }

  &__button {
    border-radius: 4px;
    width: 36px;
    height: 36px;
    cursor: pointer;

    &.active {
      background-color: rgba(var(--accent_primary), 0.3) !important;
    }
  }

  &__content {
    border-radius: var(--border-radius);
    border: 1px solid transparent;
    width: 240px;
    z-index: 1000;
    font-size: 12px;
    color: var(--white_white);
    user-select: none;
    margin-top: 8px;

    background-color: var(--modal_bg) !important;
    border-color: var(--dividers_low_contrast) !important;
  }

  &-header {
    padding: 8px;
    font-weight: bold;
    border-radius: var(--border-radius);
    text-transform: uppercase;
    color: var(--text_primary) !important;
  }

  &__list {
    padding: 8px;
  }

  &__item {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 5px;
    }

    &-key {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-value {
      margin-left: 10px;
      color: var(--text_secondary) !important;
    }

    &-symbol {
      &.nodes {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #3a8fd2;
      }

      &.links {
        width: 100%;
        height: 2px;
        background: #3a8fd2;
      }

      &.stop_points {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--white_white);
        border: 2px solid #d63838;
      }

      &.line_routes {
        width: 100%;
        height: 4px;
        background: #d63838;
      }
    }
  }
}
</style>
